import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import FontColor from "%/dynamic-component-editor/options/font-color";
import FontFamily from "%/dynamic-component-editor/options/font-family";
import FontSize from "%/dynamic-component-editor/options/font-size";
import FontWeight from "%/dynamic-component-editor/options/font-weight";
import SelectedBackgroundColor from "%/dynamic-component-editor/options/selected-background-color";
import UnselectedBackgroundColor from "%/dynamic-component-editor/options/unselected-background-color";
import BarBackgroundColor from "%/dynamic-component-editor/options/bar-background-color";
import SelectedBorder from "%/dynamic-component-editor/options/selected-border";
import UnselectedBorder from "%/dynamic-component-editor/options/unselected-border";
import BarBorder from "%/dynamic-component-editor/options/bar-border";
import normalizeFontSizeStyleValue from "%/dynamic-component-editor/helpers/font-size-style-value";
import { PLAN_SHEET_INJECTION_KEY } from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-state";

const NO_BORDER_SIDE = Object.freeze({ color: "transparent", width: "0", style: "solid" });
const NO_BORDER = Object.freeze({ top: NO_BORDER_SIDE, right: NO_BORDER_SIDE, bottom: NO_BORDER_SIDE, left: NO_BORDER_SIDE });

// The colour/border/text options the provider toggle and interval switch share, resolved for PlanSegmentedControl.
export const PlanSegmentedControlMixin = {
  mixins: [DynamicElementMixin],
  inject: {
    planSheet: { from: PLAN_SHEET_INJECTION_KEY, default: null },
  },
  options: [
    SelectedBackgroundColor,
    UnselectedBackgroundColor,
    BarBackgroundColor,
    SelectedBorder,
    UnselectedBorder,
    BarBorder,
  ],
  optionBundles: [
    new BasicTextOptions(),
    SpacingOptions,
  ],
  computed: {
    segmentStyles() {
      return {
        selectedBackground: this.getOptionValue(SelectedBackgroundColor),
        unselectedBackground: this.getOptionValue(UnselectedBackgroundColor),
        barBackground: this.getOptionValue(BarBackgroundColor),
        selectedBorder: this.getOptionValue(SelectedBorder) ?? NO_BORDER,
        unselectedBorder: this.getOptionValue(UnselectedBorder) ?? NO_BORDER,
        barBorder: this.getOptionValue(BarBorder) ?? NO_BORDER,
        text: {
          standardFontFamily: this.getOptionValue(FontFamily) || "standard",
          standardFontSize: normalizeFontSizeStyleValue(this.getOptionValue(FontSize), { element: this.$options.name, option: "font-size" }),
          standardFontColor: this.getOptionValue(FontColor) || "standard",
          standardFontWeight: this.getOptionValue(FontWeight) || "standard",
        },
      };
    },
  },
};
